import { ReactNode } from 'react';

export type HeaderTableCellProps = {
    children: ReactNode,
}

export { default as HeaderTableCell } from './HeaderTableCell';
